function ListLoader(props) {
    const { numItems = 5, component: LoadingSkeleton = () => <div /> } = props;

    return (
        <>
            {[...Array(numItems).keys()].map((key) => (
                <LoadingSkeleton key={key} />
            ))}
        </>
    );
}

export default ListLoader;
